<div class="hidden" #templateWrapper>
    <ng-content></ng-content>
</div>

<button
    #trigger
    [attr.data-testid]="currentTestId"
    [class]="class"
    (click)="triggerEvent()"
>
    <div #renderedWrapper></div>
</button>
